import React, { SVGAttributes } from 'react'

const SvgTrash = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 10 13" {...props}>
    <path
      fill="#ADAEAF"
      fillRule="evenodd"
      d="M9.287 11.623a.715.715 0 0 1-.716.715H1.43a.715.715 0 0 1-.715-.715V4.48h8.573v7.143zM10 2.856H0v-.712c0-.395.32-.715.714-.715h2.144V.716c0-.395.319-.716.714-.716H6.43c.394 0 .715.321.715.716v.713h2.143c.393 0 .713.32.713.715v.712z"
    />
  </svg>
)

export default SvgTrash
